// Shared by the server fetch and the client render: the server asks for no more
// rows than the block shows when it is not paginated.
export const DEFAULT_ARTICLES_COUNT = 25;
